module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("l8nxj"))).then(() => parcelRequire('ljYL6'));